module.exports = __webpack_public_path__ + "fd11879b865a927427f1c367a73696da.MP3";